<div class="paymentbody">
  <div id="checkout">
    <!-- Checkout will insert the payment form here -->
  </div>
</div>
